"use client";

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery, useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useCallback } from "react";
import { getIncentiveState } from "@/lib/api/incentive";
import { B3OS_ORG_COOKIE_NAME } from "@/lib/authenticatedFetch";
export type { IncentiveState, IncentiveTaskState } from "@/lib/api/incentive";
const incentiveStateKey = (orgId: string | undefined) => ["incentive", "state", orgId ?? ""] as const;
export function useIncentiveState() {
  const $ = _c(11);
  const qc = useQueryClient();
  let orgId;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    orgId = Cookies.get(B3OS_ORG_COOKIE_NAME);
    t1 = useQuery;
    t0 = incentiveStateKey(orgId);
    $[0] = orgId;
    $[1] = t0;
    $[2] = t1;
  } else {
    orgId = $[0];
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      queryKey: t0,
      queryFn: getIncentiveState,
      enabled: Boolean(orgId),
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: true
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const q = t1(t2);
  let t3;
  if ($[4] !== qc) {
    t3 = async () => {
      await qc.invalidateQueries({
        queryKey: incentiveStateKey(orgId)
      });
    };
    $[4] = qc;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const refetch = t3;
  const t4 = q.data ?? null;
  const t5 = q.isLoading || !orgId && !q.data;
  const t6 = q.error as Error | null;
  let t7;
  if ($[6] !== refetch || $[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
    t7 = {
      state: t4,
      loading: t5,
      error: t6,
      refetch
    };
    $[6] = refetch;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}